import clsx from "clsx";
import type { ChatThread } from "../types";
import { AIChatHistoryIcon } from "./AIChatHistoryIcon";

type Props = {
  thread: ChatThread;
  isActive: boolean;
  onSelect: (id: string) => void;
};

export function AIChatHistoryItem({ thread, isActive, onSelect }: Props) {
  return (
    <button
      type="button"
      onClick={() => onSelect(thread.id)}
      className={clsx(
        "flex w-full items-center gap-2.5 rounded-lg px-2.5 py-2 text-left text-sm transition-colors",
        isActive
          ? "bg-[#E8EEF5] text-[#111827] font-medium"
          : "text-[#374151] hover:bg-white/70",
      )}
    >
      <AIChatHistoryIcon
        icon={thread.icon}
        className="h-4 w-4 shrink-0 text-[#6B7280]"
      />
      <span className="truncate">{thread.title}</span>
    </button>
  );
}
